export function getPossessive(subject: string | undefined, gender: ('Male' | 'Female' | undefined)) {
    return `${subject ?? ''}'s`
}

export function getPossessivePhrase(subjectGender: ('Male' | 'Female' | undefined), obj: string) {
    switch (subjectGender) {
        case 'Male': return `his ${obj}`
        case 'Female': return `her ${obj}`
        default: return `their ${obj}`
    }
}

export function capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export function pluralize(count: number, text: PluralTextValues) {
    const values = text instanceof Array ? text : [text.singular, text.plural, text.zero ?? '']
    return count == 1 ? values[0] : (count == 0 && values[2] ? values[2] : values[1])
}

export function pluralizeWithCount(count: number, text: PluralTextValues) {
    const values = text instanceof Array ? text : [text.singular, text.plural, text.zero ?? '']
    return count == 1 ? `1 ${values[0]}` : `${count} ${values[1]}`
}

export type PluralTextValues = [string, string, string?] | PluralText;

export interface PluralText {
    singular: string;
    plural: string;
    zero?: string;
}